import { useSelector } from 'react-redux';

const useUser = () => {
  const user = useSelector(
    ({ user }) => user,
  );
  return user;
};

export default useUser;
